module.exports = __webpack_public_path__ + "static/media/twitter.d2af7277.svg";